import css from 'styled-jsx/css';

export default css`
  .cards-wrapper {
    max-width: 1230px;
    display: grid;
    grid-template-columns: repeat(auto-fit, 275px);
    gap: 20px;
    width: 100%;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }
  @media (max-width: 921px) {
    .cards-wrapper {
      grid-template-columns: repeat(3, 200px);
      gap: 20px;
      padding: 0;
    }
  }
  @media (max-width: 767px) {
    .cards-wrapper {
      grid-template-columns: repeat(3, 100px);
      gap: 15px;
      display: none;
    }
  }
  .mobile {
    display: none;
  }
  @media (max-width: 767px) {
    .mobile {
      display: grid;
    }
  }
  @media (max-width: 424px) {
    .cards-wrapper {
      grid-template-columns: repeat(3, 100px);
      gap: 5px;
    }
  }
`;
